export const checkPointsTranslationKeys = [
  { tKey: 'approve_invoice_modal.check_points.invoice_lines' },
  { tKey: 'approve_invoice_modal.check_points.payment_method' },
  { tKey: 'approve_invoice_modal.check_points.sender_info' },
  { tKey: 'approve_invoice_modal.check_points.due_date' },
]
